import { cn } from './cn'
import { t } from '@/lib/i18n'

export interface SpinnerProps {
  size?: number
  className?: string
  /** Accessible label (default: "Loading", translated); pass an empty string when a parent already announces loading. */
  label?: string
}

/** Circular loading indicator that follows the current text colour. */
export function Spinner({ size = 16, className, label: labelProp }: SpinnerProps) {
  // Resolved at render time so the default follows the active language (Q-SRCH-33).
  const label = labelProp ?? t('Loading')
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      role={label ? 'status' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn('mgs-spin shrink-0 animate-spin-fast', className)}
    >
      <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeOpacity="0.22" strokeWidth="3" />
      <path d="M21.5 12a9.5 9.5 0 0 0-9.5-9.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}
